// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260318-8/static/css/" + chunkId + "." + {"865":"0f6af5d1","1059":"0f6af5d1","2395":"0f6af5d1","2425":"0f6af5d1","2982":"07a465cd","3583":"e7ad2344","4624":"e7ad2344","8395":"e7ad2344","8795":"e7ad2344"}[chunkId] + ".chunk.css";
};